import React, { useState, useEffect, useContext, useRef } from "react";
import mainContext from "../context/MainContext/mainContext";
import { useSelector } from "react-redux";
import moment from "moment";
import { Select, notification, Button, Input, Modal } from "antd";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { emptyDraft } from "../../../../toolkit/slices/inventories/inventorySlice";
import ExcelJS from "exceljs";
import { RiBillLine } from "react-icons/ri";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { CloseOutlined, SketchSquareFilled } from "@ant-design/icons";
import formatIndianNumber from "../../../../../utils/formatIndianNumber";
import { isImmediateNonLedForBlockCart } from "../../../../../utils/getProposalAvailableFromLabel";
import { saveAs } from "file-saver";
import ableToModify from "../../../../../utils/ableToModify";
import isEmailAllowed from "../../../../../utils/isEmailAllowed";
import { addProposalInventories } from "../../../../toolkit/slices/proposalInventories/proposalInventorySlice";
import { addToCart } from "../../../../toolkit/slices/cart/cartSlice";
import Share from "../../../containers/ShareToOtherPlatforms/index";
import handleDownloadExcel from "../utils/handleDownloadExcel";
import generatePresentation from "../utils/generatePresentation";
import { WhatsappIcon } from "react-share";

const FileInputWithHistoryView = ({
  toggleList,
  isOpen,
  ind,
  data,
  length,
  setOk,
  propId,
  setIsEditable,
  entirePropData,
  accepted,
  index,
  client,
  clientId,
  PR,
  setPR,
  downloadAllowed,
  setEditProposal,
  excelURL,
  setExcelURL,
  pptURL,
  setPptURL,
}) => {
  const {
    setInventories,
    setProposalId,
    setFetchProp,
    setShowLoader,
    apiBaseUrl,
    sendingLoader,
    setSendingLoader
  } = useContext(mainContext);

  let userEmail = useSelector((state) => state.user.email);
  let userId = useSelector((state) => state.user._id);
  const cart = useSelector((state) => state.cartSpace.cart);
  const displayClientName =
    entirePropData?.clientName ?? entirePropData?.client?.name;
  const [subject, setSubject] = useState("Proposal");
  const [selectedEmails, setSelectedEmail] = useState(null);
  const [bodyOfEmail, setBodyOfEmail] = useState("");
  const [emailOptions, setEmailOptions] = useState([]);
  const [inputEmail, setInputEmail] = useState("");
  const [modalVisibleEmail, setModalVisibleEmail] = useState(false);
  const shareButtonRef = useRef(null);


  console.log("userId:::: ", userId);

  useEffect(() => {
    setBodyOfEmail(`<p>Dear Sir,</p>
      <br/>
      <p>Please find below the links to download the proposal documents:</p>
      <br/>
      <br/>
      <p><a href="${encodeURI(pptURL)}">Download PowerPoint presentation</a></p>
      <br/>
      <br/>
      <p><a href="${encodeURI(excelURL)}">Download Excel file</a></p>
      <br/>
      <br/>
      <p>Awaiting your positive response for the same.</p>
      <br/>
      <p>Best regards,</p>
      <br/>
      <p>Yellow Spot</p>
      <br/>
     `);
  }, [excelURL, pptURL]);
  const handleWhatsappShare = async (
    proposals,
    clientName,
    PR,
    proposalData
  ) => {
    // Step: Perform asynchronous operations concurrently
    console.log("handleWhatsappShare called");
    setSendingLoader(true);
    await Promise.all([
      handleDownloadExcel(
        clientName,
        proposals,
        PR,
        proposalData,
        true,
        setShowLoader,
        setExcelURL
      ),
      generatePresentation(
        proposals,
        clientName,
        PR,
        proposalData,
        true,
        setShowLoader,
        setPptURL,
        userId
      ),
    ]);
    setSendingLoader(false)
  };

  // useEffect(() => {
  //   async function fetchEmails() {
  //     try {
  //       let response = await fetch(
  //         `${apiBaseUrl}/inventoryManagement/listEmails`,
  //         {
  //           method: "GET",
  //           credentials: "include",
  //         }
  //       );
  //       if (!response.ok) {
  //         throw new Error(`HTTP error! status: ${response.status}`);
  //       }
  //       let responseJson = await response.json();
  //       let emails = responseJson?.emails?.map((ele) => ele.emailId) || [];
  //       setEmailOptions(emails);
  //     } catch (error) {
  //       console.error("Error fetching emails:", error);
  //     }
  //   }
  //   fetchEmails();
  // }, []);

  const handleEmail = async (proposals, clientName, PR, proposalData) => {
    setSendingLoader(true);
    try {
      let response = await fetch(
        `${apiBaseUrl}/inventoryManagement/listEmails`,
        {
          method: "GET",
          credentials: "include",
        }
      );
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      let responseJson = await response.json();
      let emails = responseJson?.emails?.map((ele) => ele.emailId) || [];
      setEmailOptions(emails);
    } catch (error) {
      console.error("Error fetching emails:", error);
    }
    await Promise.all([
      handleDownloadExcel(
        clientName,
        proposals,
        PR,
        proposalData,
        true,
        setShowLoader,
        setExcelURL
      ),
      generatePresentation(
        proposals,
        clientName,
        PR,
        proposalData,
        true,
        setShowLoader,
        setPptURL,
        userId
      ),
    ]);
    
    setSendingLoader(false);

    // Setting modal visibility to true after both promises have resolved
    setModalVisibleEmail(true);
  };

  const { Option } = Select;
  const modules = {
    toolbar: [
      [
        { bold: true },
        { italic: true },
        { underline: true },
        { link: true },
        { emoji: true },
      ],
    ],
  };

  const formats = ["bold", "italic", "underline", "link", "emoji"];
  const handleSubjectChange = (e) => {
    setSubject(e.target.value);
  };
  const handleInputConfirm = () => {
    if (inputEmail && !selectedEmails.includes(inputEmail)) {
      setSelectedEmail([...selectedEmails, inputEmail]);
      setInputEmail("");
    }
  };
  const handleEmailSelect = (selectedItems) => {
    setSelectedEmail(selectedItems);
  };
  const handleCancelEmail = () => {
    setModalVisibleEmail(false);
  };
  const handleTextArea = (value) => {
    setBodyOfEmail(value);
    console.log("This vallll", value);
  };
  const saveEmailIfItsNew = async (emails) => {
    let newEmails = emails.filter((ele) => !emailOptions.includes(ele));
    let requestBody = {
      emails: newEmails,
    };
    try {
      let response = await fetch(
        `${apiBaseUrl}/inventoryManagement/saveNewEmails`,
        {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestBody),
        }
      );
      let responseJSON = response.json();
      if (response.ok) {
        console.log(responseJSON.message);
      }
    } catch (err) {
      notification.error({ message: err.message, duration: 0.3 });
    }
  };
  const handleOkEmail = async () => {
    try {
      let source = "";

      if (userId == "6655da0d21d3e92d1b400e27") {
        source = "sales@yellowspot.in";
      } else if (userId == "6655d9b40777525410c88982") {
        source = "aksha.shah@yellowspot.in";
      } else if (userId == "6655da0db7fa235637d8803a") {
        source = "mediaplanning@yellowspot.in";
      } else if (userId == "668bb8a8dc1b17763bfc16bd") {
        source = "pankaj.vyas@yellowspot.in";
      } else if (userId == "668bb8a98846df09d6649fc3") {
        source = "meet.javia@yellowspot.in";
      } else if (userId == "668bb8a86a5e8031326ead83") {
        source = "saurabh.sharma@yellowspot.in";
      } else if (userId == "6655d9b40777525410c88982") {
        source = "aksha.shah@yellowspot.in";
      } else if (userId == "6655da0d21d3e92d1b400e27") {
        source = "sales@yellowspot.in";
      }
      console.log("this is theeeee data", data);
      const requestBody = {
        subject,
        email: selectedEmails,
        finalUrl1: pptURL,
        finalUrl2: excelURL,
        source,
        userId,
        bodyOfEmail,
      };

      const response = await fetch(
        `${apiBaseUrl}/autosend/sendEmailForYellowSpotForWeb`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            authorization: `Token ${window.localStorage.getItem("token")}`,
          },
          body: JSON.stringify(requestBody),
        }
      );

      const data1 = await response.json();
      if (data1.success) {
        notification.success({ message: "Email has been sent successfully" });
        await saveEmailIfItsNew(selectedEmails);
        // await generateEmailSrNo();
        navigate("/approvals");
      } else {
        notification.error({ message: data1.message });
      }
    } catch (error) {
      notification.error({ message: error.message });
    }
    setModalVisibleEmail(false);
  };
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleBlockInventoriesToCart = () => {
    const inCart = new Set((cart || []).map((c) => c._id));
    const toAdd = [];
    (data?.proposals || []).forEach((p) => {
      const inv = p?.invId;
      if (!inv?._id || !isImmediateNonLedForBlockCart(inv)) return;
      if (inCart.has(inv._id)) return;
      toAdd.push(inv);
      inCart.add(inv._id);
    });
    if (toAdd.length === 0) {
      notification.info({
        message: "Nothing to add",
        description:
          "No non-LED inventories with Immediate availability, or they are already in the cart.",
      });
      return;
    }
    toAdd.forEach((inv) => dispatch(addToCart(inv)));
    notification.success({
      message: `${toAdd.length} inventory(s) added to cart`,
      duration: 2,
    });
  };

  async function handleExcelComparison(id) {
    try {
      const data = await fetchExcelComparison(id);
      if (data) {
        // Call the excelGeneration function with the retrieved data
        excelGeneration(data);
      } else {
        console.log("No data retrieved.");
      }
    } catch (err) {
      console.error(`Error: ${err.message}`);
    }
  }

  async function fetchExcelComparison(id) {
    try {
      const response = await fetch(
        `${apiBaseUrl}/inventoryManagement/proposalComparison`,
        {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ id }),
        }
      );
      const responseData = await response.json();
      return responseData.data; // Return the data property of the response
    } catch (err) {
      console.error(`Error: ${err.message}`);
      return null;
    }
  }

  function excelGeneration(data) {
    let TotalsOfEachProposals = [];

    // Calculate totals for each proposal
    for (let i = 0; i < data[0].proposalInfo.length; i++) {
      let add = 0;
      data.forEach((ele) => {
        let total;
        if (
          ele.proposalInfo[i].mountingCharge == "-" ||
          ele.proposalInfo[i].printingCharge == "-" ||
          ele.proposalInfo[i].specialRate == "-"
        ) {
          total = 0;
        } else {
          total =
            Number(ele.proposalInfo[i].mountingCharge) +
            Number(ele.proposalInfo[i].printingCharge) +
            Number(ele.proposalInfo[i].specialRate);
        }
        add += total;
      });
      TotalsOfEachProposals.push(add);
    }

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Proposals");

    // Header row
    worksheet.addRow(["Excel Comparison Between Generated Proposals"]);
    worksheet.addRow([]);
    worksheet.addRow([]);

    let header = ["Inventories"];
    data[0].proposalInfo.forEach((ele, ind) => {
      header.push(`Proposal ${ind + 1}`, "", "", "");
    });
    worksheet.addRow(header);

    // Data rows
    data.forEach((ele, ind) => {
      let headerPrice = [ele.location];
      let valuePrice = [" "];

      ele.proposalInfo.forEach((elem, index) => {
        let headerP = ["PC", "MC", "SR", "RPM"];
        let valueP = [
          elem.printingCharge,
          elem.mountingCharge,
          elem.specialRate,
          elem.rpm,
        ];
        headerPrice.push(...headerP);
        valuePrice.push(...valueP);
      });

      worksheet.addRow(headerPrice);
      worksheet.addRow(valuePrice);
    });

    // Totals row
    let totalBottomHeader = [" "];
    let totalBottomData = [" "];
    TotalsOfEachProposals.forEach((ele) => {
      totalBottomHeader.push("Total", "", "", "");
      totalBottomData.push(`${ele}`, "", "", "");
    });
    worksheet.addRow(totalBottomHeader);
    worksheet.addRow(totalBottomData);

    // Styling the totals row
    const lastRow = worksheet.lastRow;
    lastRow.eachCell((cell, colNumber) => {
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FFFF00" }, // Yellow background
      };
      cell.font = {
        bold: true,
      };
    });

    // Adjust column widths
    worksheet.columns = [
      { width: 30 },
      { width: 10 },
      { width: 10 },
      { width: 10 },
      { width: 10 },
      { width: 10 },
      { width: 10 },
      { width: 10 },
      { width: 10 },
      { width: 10 },
      { width: 10 },
      { width: 10 },
    ];

    // Merge header cells
    let col = 1;
    data[0].proposalInfo.forEach(() => {
      worksheet.mergeCells(4, col + 1, 4, col + 4); // Merging cells for 'Proposal' header
      col += 4;
    });

    // Create a workbook and write to file
    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], { type: "application/octet-stream" });
      saveAs(blob, `${client} Proposal EXCEL Comparison.xlsx`);
    });
  }

  function s2ab(s) {
    const buf = new ArrayBuffer(s.length);
    const view = new Uint8Array(buf);
    for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff;
    return buf;
  }

  function handleViewEdit(data, edit) {
    setInventories(
      data.proposals.map((ele) => ({
        // _id: ele._id,
        rpm: ele.rpm,
        mountingCharge: ele.mountingCharge,
        printingCharge: ele.printingCharge,
        specialRate: ele.specialRate,
        innovationRate: ele.innovationRate || 0,
        locationArea: ele.invId.locations.name,
        invId: ele.invId._id,
      }))
    );

    setProposalId(propId);
    setOk((prev) => !prev);
    setIsEditable(true);
    setPR(data?.packageRate);
    if (edit) {
      setEditProposal(edit);
    } else {
      setEditProposal(false);
    }
  }

  function handleBDFCreation(data, gst, proposalId) {
    let packageRate = data.packageRate;
    let info = data.proposals.map((item) => {
      return {
        _id: item?.invId._id,
        codeNo: item?.invId.CodeNo,
        vendor: item?.invId.vendor,
        img: item?.invId.img,
        area: item?.invId.locations.Area,
        location: item?.invId.locations.name,
        mediaVehicle: item?.invId.typeOfMedia.name,
        width: item?.invId.width,
        height: item?.invId.height,
        Illu: item?.invId.Illu,
        Bookings: item?.invId.Bookings,
        blockedDates: item?.invId.blockedDates,
        sqFt: item?.invId.width * item?.invId.height,
        mountingCharge: item?.mountingCharge,
        printingCharge: item?.printingCharge,
        specialRate: item?.specialRate,
        specialRatePerMonth: item?.specialRate,
        innovationRate: item?.innovationRate || 0,
        ratePerMonth: item?.invId.ratePerMonth,
        half1Id: item?.invId?.half1Id,
        half2Id: item?.invId?.half2Id,
        fullId: item?.invId?.fullId,
      };
    });

    let dt = {
      GST: gst,
      clientName: client,
      clientId: clientId,
      packageRate,
      invs: info,
      proposalId,
    };
    // console.log(packageRate, info, dt)
    dispatch(addProposalInventories(dt));
    dispatch(emptyDraft());
    navigate(`/clients-bdf/direct-bdf`);
  }
  const approveProposal = async () => {
    let invs = data.proposals.map((ele) => ({
      // _id: ele._id,
      rpm: ele.rpm,
      mountingCharge: ele.mountingCharge,
      printingCharge: ele.printingCharge,
      specialRate: ele.specialRate,
      innovationRate: ele.innovationRate,
      locationArea: ele.invId.locations.name,
      invId: ele.invId._id,
    }));
    try {
      const data = {
        id: propId,
        proposalInvs: invs,
        packageRate: PR,
      };
      const response = await fetch(
        `${apiBaseUrl}/inventoryManagement/approveProposal`,
        {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        }
      );

      const responseData = await response.json();

      if (responseData.success) {
        notification.success({ message: responseData.message });
        setFetchProp((prev) => !prev);
      } else {
        console.error("Error editing proposal:", responseData.message);
      }
    } catch (err) {
      console.error("Error fetching proposal:", err.message);
    }
  };
  const emailToClient = async () => {
    // setEmailModal(true);
    const isGenerateLink = true;
    console.log("Email function called");
    await handleDownloadExcel(
      displayClientName,
      data.proposals,
      data.packageRate,
      data,
      false,
      setShowLoader,
      setExcelURL
    );
    await generatePresentation(
      data.proposals,
      displayClientName,
      PR,
      data,
      false,
      setShowLoader,
      setPptURL,
      userId
    );
  };

  // const handleEmail = async (proposals, clientName, PR, proposalData) => {
  //   // await handleDownloadExcel(clientName, proposals, PR, proposalData, true);
  //   // await generatePresentation(proposals, clientName, PR, proposalData, true);
  //   setModalVisibleEmail(true);
  // };

  return (
    <div
      className="proposal-list fileInput first-prop"
      onClick={() => toggleList(ind)}
    >
      <div className="proposal-date">
        <div className="proposal-date-child">
          <span>{moment(data.createdAt).format("MMM")}</span>
          <span>{moment(data.createdAt).format("DD")}</span>
          <span>{moment(data.createdAt).format("ddd")}</span>
        </div>
        <span className="date-vertical-border"></span>
      </div>
      <div>
        <div>{displayClientName ?? client}</div>
        <div style={{ whiteSpace: "nowrap" }}>
          Proposal ID: #{Number(index) + 1}{" "}
          <span
            style={{
              fontSize: "14px",
              color: `${entirePropData.proposalStatus == "accepted" ? "green" : "orange"
                }`,
            }}
          >
            {entirePropData.proposalStatus}
          </span>
        </div>
        <div>By {data.createdBy.name}</div>
      </div>
      <div className="proposal-info-dt">
        {data.packageRate ? (
          <div className="proposal-info-dt-child">
            <span>Package Rate</span>
            <div>₹ {formatIndianNumber(data.packageRate)}</div>
          </div>
        ) : (
          data.totalProposalPrice !== 0 && (
            <div className="proposal-info-dt-child">
              <span>Amount</span>
              <div>₹ {formatIndianNumber(data.totalProposalPrice)}</div>
            </div>
          )
        )}

        <div className="proposal-info-dt-child">
          <span>Inventory Count</span>

          <div>({data.proposals.length})</div>
        </div>
      </div>
      {downloadAllowed && (
        <div
          className="proposal-download-spec"
          style={{ display: "flex", alignItems: "center" }}
        >
          <div
            style={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}
          >
            <Button
              onClick={() => {
                console.log("data: ", data);
                handleDownloadExcel(
                  displayClientName,
                  data.proposals,
                  data.packageRate,
                  data,
                  false,
                  setShowLoader,
                );
              }}
            >
              EXCEL
            </Button>

            <Button
              onClick={() => {
                generatePresentation(
                  data.proposals,
                  displayClientName,
                  PR,
                  data,
                  false,
                  setShowLoader,
                );
              }}
            >
              PPT
            </Button>
          </div>

          <div
            style={{ marginLeft: "2rem", cursor: "pointer" }}
            onClick={async () => {
              await handleWhatsappShare(
                data.proposals,
                displayClientName,
                PR,
                data
              );
              if (shareButtonRef.current) {
                shareButtonRef.current.click();
              }
            }}
          >
            <WhatsappIcon size={32} round />
          </div>
          <div style={{ position: "absolute", visibility: "hidden" }}>
            <Share ref={shareButtonRef} pptLink={pptURL} excelLink={excelURL} />
          </div>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "0.5rem",
              margin: "1.5rem",
            }}
          >
            <Button
              type="primary"
              onClick={() => {
                handleEmail(data.proposals, displayClientName, PR, data);
                // setModalVisibleEmail(true);
              }}
            >
              Email
            </Button>
            <Button onClick={handleBlockInventoriesToCart}>
              Block inventories
            </Button>
          </div>
          <style>
            {`
          .custom-modal-email .ant-modal-content {
            border-radius: 1% !important; /* Rounded corners */
            width: 596px !important; /* Fixed width */
            height: 615px !important; /* Fixed height */
            max-width: 100% !important; /* Ensure responsiveness */
            max-height: 100% !important; /* Ensure responsiveness */
            overflow: hidden; /* Hide overflow to maintain rounded corners */
            padding:0px
          }
          .custom-modal-email .ant-modal-header,
          .custom-modal-email .ant-modal-footer {
            border-radius: 20% 20% 0 0 !important; /* Rounded corners for header */
          }
          .custom-modal-email .ant-modal-close {
            border-radius: 50% !important; /* Optional: Round the close button */
          }
          .custom-modal-email .ant-modal-body {
            padding: 0px !important; /* Remove padding */
          }
          .custom-modal-email .ant-modal-content {
            border-radius: 1% !important;
            width: 596px !important;
            height: 615px !important;
            max-width: 100% !important;
            max-height: 100% !important;
            overflow: hidden !important;
            padding: 0px !important;
          }
          .custom-modal-email .custom-close-button {
            position: absolute;
            top: 4px; /* Adjust position */
            right: 12px; /* Adjust position */
            background: transparent;
            border: none;
            cursor: pointer;
            font-size: 18px; /* Size of the icon */
            color: #444746; /* Color of the icon */
            z-index: 1000; /* Ensure it’s on top */
  
          }
          .custom-modal-email .custom-close-button:hover,
          .custom-modal-email .custom-close-button:focus {
            color: #000 !important; /* Ensure color remains the same on hover and focus */
            background: transparent !important; /* Ensure background remains transparent */
            box-shadow: none !important; /* Remove any shadow */
            border: none !important; /* Remove any border */
          }
          .ant-select-selector.custom-dropdown {
          
  
            /* Add any additional custom styles here */
          }
        
        `}
          </style>
          <Modal
            visible={modalVisibleEmail}
            onOk={handleOkEmail}
            onCancel={handleCancelEmail}
            className="custom-modal-email" // Apply the custom class
            // This controls the padding of the outer modal wrapper
            footer={null}
            // Removes padding from the modal body
            closable={false}
            style={{
              padding: "0px",
              position: "relative",
            }}
          >
            <div style={{ height: "100%", width: "100%" }}>
              <div style={{ backgroundColor: "#F2F6FB" }}>
                <h6
                  style={{
                    padding: "10px",
                    fontFamily: "Google Sans, sans-serif",
                  }}
                >
                  New Message
                </h6>
                <button
                  className="custom-close-button"
                  onClick={handleCancelEmail}
                >
                  {" "}
                  <CloseOutlined />
                </button>
              </div>

              <div>
                <div className="custom-menu-email" style={{ padding: "10px" }}>
                  <Select
                    mode="tags"
                    style={{
                      width: "100%",
                    }}
                    placeholder="Recipients"
                    onChange={handleEmailSelect}
                    value={selectedEmails}
                    onInputKeyDown={(e) => {
                      if (e.key === "Enter") {
                        handleInputConfirm();
                      }
                    }}
                    onBlur={handleInputConfirm}
                    className="custom-dropdown" // Optional: to style the dropdown menu
                  >
                    {emailOptions.map((email, index) => (
                      <Option key={index} value={email}>
                        {email}
                      </Option>
                    ))}
                  </Select>
                  <br />
                  <br />
                  <Input
                    style={{
                      marginBottom: "10px",
                      border: "none",
                      borderBottom: "1px solid #BFBFBF",
                      borderRadius: "0",
                    }}
                    placeholder="Enter the subject"
                    value={subject}
                    onChange={handleSubjectChange}
                    onMouseOver={(e) =>
                      (e.currentTarget.style.borderBottom = "1px solid #BFBFBF")
                    }
                    onFocus={(e) => (e.currentTarget.style.border = "0px")}
                    onMouseOut={(e) =>
                      (e.currentTarget.style.borderBottom = "1px solid #BFBFBF")
                    }
                  />
                  <br />
                  <div
                    style={{
                      width: "500px",
                      position: "relative",
                      border: "0px",
                    }}
                  >
                    <ReactQuill
                      value={bodyOfEmail}
                      onChange={handleTextArea}
                      placeholder="Content of the body"
                      modules={modules}
                      formats={formats}
                      style={{
                        height: "300px",
                        border: "0px",
                        outline: "none",
                      }} // Remove border and outline
                    />
                    {/* Apply CSS to remove borders from the toolbar and editor */}
                    <style jsx="true">{`
                      .ql-toolbar {
                        position: absolute;
                        bottom: -45px;
                        left: 0;
                        right: 0;
                        width: 100%;
                        display: flex;
                        justify-content: center;
                        border: 0px !important; /* Ensure no border on toolbar */
                      }
                      .ql-container {
                        border: 0px !important; /* Remove border from editor container */
                      }
                      .ql-editor {
                        border: 0px !important; /* Remove border from the editable area */
                        outline: none; /* Remove any outline on focus */
                      }
                    `}</style>
                  </div>

                  <br />
                  <br />
                  <hr />
                  <br />
                  <Button
                    type="primary"
                    onClick={handleOkEmail}
                    style={{
                      borderRadius: "50px",
                      backgroundColor: "#0957D0",
                      borderColor: "#0957D0",
                    }}
                  >
                    Send
                  </Button>
                </div>
                <br />
              </div>
            </div>
          </Modal>
        </div>
      )}
      {/* <Button type="primary" onClick={emailToClient}>
          Email
        </Button> */}
      <div
        style={{ color: "#30b5e9", cursor: "pointer" }}
        onClick={() => handleViewEdit(data, false)}
      >
        View
      </div>
      {ableToModify(data?.createdBy?._id, userId) && (
        <div
          style={{ color: "#30b5e9", cursor: "pointer" }}
          onClick={() => handleViewEdit(data, true)}
        >
          Edit
        </div>
      )}

      {/* { {length > 1 ? (
          <div
            style={{ color: "#30b5e9", cursor: "pointer" }}
            onClick={() => toggleList(ind)}
          >
            History
          </div> 
         ) : null} } */}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "1rem",
          marginLeft: "auto",
        }}
      >
        <Button onClick={() => handleExcelComparison(propId)}>
          Excel Comparison
        </Button>
        {accepted && (
          <Button
            type="primary"
            icon={<RiBillLine />}
            onClick={() =>
              handleBDFCreation(
                data,
                entirePropData?.client?.gstNumber,
                data?._id
              )
            }
          >
            Create BDF
          </Button>
        )}
        {!accepted && isEmailAllowed(userEmail) && (
          <Button
            type="primary"
            icon={<RiBillLine />}
            onClick={() => approveProposal()}
          >
            Approve
          </Button>
        )}
      </div>
    </div>
  );
};
export default FileInputWithHistoryView;
